import React from "react";
import PropTypes from "prop-types";
import { RadioButtonGroup, RadioButton } from 'carbon-components-react';
function RadioWidget(props) {
  const {
    options,
    value,
    required,
    disabled,
    readonly,
    autofocus,
    onBlur,
    onFocus,
    onChange,
    id,
  } = props;
  // Generating a unique field name to identify this set of radio buttons
  const name = Math.random().toString();
  const { enumOptions, enumDisabled, inline } = options;
  // checked={checked} has been moved above name={name}, As mentioned in #349;
  // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.
  return (
    <RadioButtonGroup
      className="some-class-radio-group"
      id={id}
      defaultSelected={null}
      valueSelected={null}
      name={'radio-button-group-'+id}
      orientation='horizontal'
      labelPosition='right'
      onChange={(event) => onChange(event)}
      onBlur={onBlur && (event => onBlur(id, event))}
      onFocus={onFocus && (event => onFocus(id, event))}
    >
      {
        enumOptions.map((option, i) => {
          //const checked = option.value === value;
          const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
          return (<RadioButton 
            key={id+'_' +i}
            className='some-class-radio'
            labelText={option.label}
            labelPosition='right'
            //checked={checked}
            name={name}
            value={option.value}
            disabled={disabled || itemDisabled || readonly}
            required={required}
            autoFocus={autofocus && i === 0}
    
          />);
        })
      }
    </RadioButtonGroup >
  );
}

RadioWidget.defaultProps = {
  autofocus: false,
};

if (process.env.NODE_ENV !== "production") {
  RadioWidget.propTypes = {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
      enumOptions: PropTypes.array,
      inline: PropTypes.bool,
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func,
  };
}
export default RadioWidget;
